<template>
    <div class="column">
        <div class="advanced-search-card card" :class="{'is-visited': isVisited, 'has-bid': hasEnquiry}">
            <div class="card-content">
                <div class="media">
                    <div class="media-left">
                        <figure class="image is-65x65" @click="openGallery">
                            <img :src="lot.images + '&h=50'">
                        </figure>
                    </div>
                    <div class="media-content"  @click="goToLotSinglePage" >
                        <div class="subtitle is-6"><b><span class="car-name">{{ lot.manuf_name }} {{ lot.model_name }} {{ lot.grade }}</span></b></div>
                        <p class="title is-6"><b>{{ lot.lot_num }} /</b> {{ lot.year }} </p>
                        <p class="details"><span v-html="lot.body"></span> / {{ lot.Vcc }} cc / {{ lot.mileage | formatNumber }} km </p>
                        <p class="details">{{ lot.colour }} / {{ lot.transmission  }} / {{ lot.rate }}</p>
                    </div>
                </div>

                <div class="content ">
                    <a href="#" class="auction"  @click="goToLotSinglePage" >
                        {{ lot.auct_date.split(' ')[1] }}
                        {{ lot.auct_date.split(' ')[0] }}
                        @ {{ lot.auct_name }}</a>
                </div>
                <div class="card-footer">
                    <div class="card-footer-item justify-space-between">
                        <div class="color-danger">PRICE: {{ lot.price_start | formatNumber }} YEN</div>
                        <button class="button is-small is-primary enquiry has-tooltip-primary" data-tooltip="Do you want to pay lesser for this car? let us know how much!" @click="counterOffer">Counter-offer</button>
                        <button class="button is-small is-danger enquiry" @click="enquiry">Enquiry</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        components: {

        },
        props:['lot', 'index', 'user'],
        methods: {
            goToLotSinglePage() {
                this.$store.dispatch('setLotToIsVisitedStock', this.lot.lot_id)
                this.$router.push({
                    path: '/buy-now/' + this.lot.lot_id,
                })
            },
            enquiry(){
                this.$store.dispatch('changeSearchResultActiveLotKeyEnquiry', this.index)
                this.$store.dispatch('setStockCarAlertDetails', {stockCarAlertModalStatus: true, stockCarAlertMessage: null, carObj: {lot: this.lot, user: this.user, counterOffer:false}, isResponse: false})
            },
            counterOffer(){
                this.$store.dispatch('changeSearchResultActiveLotKeyEnquiry', this.index)
                this.$store.dispatch('setStockCarAlertDetails', {stockCarAlertModalStatus: true, stockCarAlertMessage: null, carObj: {lot: this.lot, user: this.user, counterOffer:true}, isResponse: false})
            },
            openGallery() {
                var gallery = this.lot.images.split('#');
                gallery.unshift(this.lot.auction_list)
                this.$store.dispatch('setResultGalleryItems', gallery)
                this.$store.dispatch('setResultGalleryOptions', { index: 0 })
                this.$store.dispatch('setResultGalleryStatus', true)
                this.$store.dispatch('setResultGalleryCar', this.lot)
            }
        },
        computed: {
            isVisited() {
                return this.$store.getters.checkIfLotIsVisitedStock(this.lot.lot_id)
            },
            hasEnquiry() {
                return !!this.lot.enquiry.length;
            }
        }
    }
</script>

<style scoped>
    p {
        max-width: 170px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .auction {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #4a4a4a;
    }

    .car-name {
        overflow: hidden;
        max-width: 100%;
        word-wrap: break-word;
        display: inline-block;
        text-overflow: ellipsis;
    }
    .card-content {
        padding: 10px !important;
    }
    .column {
        padding: 5px !important;
    }
    .image {
        width: 135px;
        cursor: pointer;
    }

    .card-footer-item {
        padding: 2px !important;
    }

    .card-footer-item:not(:last-child) {
        border-right: none !important;
    }

    .card-footer {
        border-top: none !important;
    }

    .title {
        margin-top: 5px !important;
        margin-bottom: 5px !important;
    }

    .subtitle {
        margin-bottom: 5px !important;
    }

    .title:not(.is-spaced)+.subtitle {
         margin-top: 0 !important;
    }

    .details {
        font-size: 12px !important;
        margin-top: 10px;
    }

    .content {
        margin-bottom: 5px !important;
    }

    .card .media:not(:last-child) {
        margin-bottom: 5px !important;
    }

    .is-visited {
        background: #a9ddff !important;
    }
    .has-bid {
        background: rgba(236, 209, 100, 0.57)!important;
    }
</style>



// WEBPACK FOOTER //
// src/components/StockCars/AdvanceStockCarMobile.vue